var cross16 = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" class=\"trustpilot-icon\"><path d=\"M7.294 8 2 13.294l.706.706L8 8.706 13.294 14l.706-.706L8.706 8 14 2.706 13.294 2 8 7.294 2.706 2 2 2.706 7.294 8Z\"/></svg>";

export { cross16 as default };
//# sourceMappingURL=cross_16.svg.js.map
